import { useLocation } from 'react-router-dom';
import { resolvePath, pathFor } from '../content/routes';
import { en } from '../content/en';
import { pt } from '../content/pt';

const CONTENT = { en, pt };

export function useLang() {
  const { pathname } = useLocation();
  const { pageKey, lang, slug } = resolvePath(pathname);
  const t = CONTENT[lang];
  const link = (key, targetLang, s) => pathFor(key, targetLang || lang, s ?? slug);
  return { lang, pageKey, slug, t, link };
}
